export default "__VITE_ASSET__B$mgpsFo__"